const checkFieldValidity = (value, rules = [], t) => {
    let valid = true;
    let errors = [];

    for (const rule of rules) {
        switch (rule.type) {
            case `notEmpty`:
                valid = value.toString().trim() !== '' && valid;
                if (value.toString().trim() === '') {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.notEmpty'));
                }
                break;
            case `validOnEmpty`: {
                valid = (value.length === 0 ? true : valid);
                if (value.length === 0) {
                    errors = [];
                }
                break
            }
            case `minLength`:
                valid = value.length >= rule.length && valid
                if (value.length < rule.length) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : `${t('checkFieldValidity.minLength.p1')} ${rule.length} ${t('checkFieldValidity.minLength.p2')}`);
                }
                break;
            case `maxLength`:
                valid = (value.length <= rule.length) && valid
                if (value.length > rule.length) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : `${t('checkFieldValidity.maxLength.p1')} ${rule.length} ${t('checkFieldValidity.minLength.p2')}`);
                }
                break;
            case `iterableMinLength`:
                valid = value.length >= rule.length && valid
                if (value.length < rule.length) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : `${t('checkFieldValidity.iterableMinLength.p1')} ${rule.length} ${t('checkFieldValidity.iterableMinLength.p2')}`);
                }
                break;
            case `iterableMaxLength`:
                valid = (value.length <= rule.length) && valid
                if (value.length > rule.length) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : `${t('checkFieldValidity.iterableMaxLength.p1')} ${rule.length} ${t('checkFieldValidity.iterableMaxLength.p2')}`);
                }
                break;
            case `isEmail`:
                const isEmailPattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                valid = isEmailPattern.test(value) && valid;

                if (!isEmailPattern.test(value)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.isEmail'));
                }
                break;
            case `isURL`:
                const isURLPattern = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
                valid = isURLPattern.test(value) && valid;
                if (!isURLPattern.test(value)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.isURL'));
                }
                break;
            case `isNumeric`:
                const isNumericPattern = /^\d+$/;
                valid = isNumericPattern.test(value) && valid;
                if (!isNumericPattern.test(value)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.isNumeric'));
                }
                break;
            case `atLeastOneDigitOrLetter`:
                const atLeastOneDigitOrLetterPattern = /([A-Z\d\u00BF-\u1FFF\u2C00-\uD7FF])/i;
                valid = atLeastOneDigitOrLetterPattern.test(value) && valid;
                if (!atLeastOneDigitOrLetterPattern.test(value)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.atLeastOneDigitOrLetter'));
                }
                break
            case `noRepeatingSpaces`:
                const noRepeatingSpacesPattern = /^(?!.*(\s)\1{1})/i;
                valid = noRepeatingSpacesPattern.test(value) && valid;
                if (!noRepeatingSpacesPattern.test(value)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.noRepeatingSpaces'));
                }
                break
            case `noSpaces`:
                const noSpacesPattern = /^\S*$/;
                valid = noSpacesPattern.test(value) && valid;
                if (!noSpacesPattern.test(value)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.noSpaces'));
                }
                break
            case `isEqual`: {
                valid = (value === rule.equalTo) && valid;
                if (!(value === rule.isEqual)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : `${t('checkFieldValidity.isEqual.p1')} "${rule.equalTo}"${t('checkFieldValidity.isEqual.p2')}`);
                }
                break;
            }
            case `isPhoneNumber`: {
                const isPhoneNumberPattern = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g;
                valid = isPhoneNumberPattern.test(value) && valid;
                if (!(isPhoneNumberPattern.test(value))) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.isPhoneNumber'));
                }
                break;
            }
            case `iterableNotEmpty`: {
                valid = (value.length !== 0) && valid;
                if (value.length === 0) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : t('checkFieldValidity.iterableNotEmpty'));
                }
                break
            }
            case `fileMaxSizeMB`: {
                valid = (value[0] ? (value[0].size / 1024 / 1024 > rules.find(rule => rule.type === 'fileMaxSizeMB').value ? false : true) : false) && valid;
                if (!(value[0] ? (value[0].size / 1024 / 1024 > rules.find(rule => rule.type === 'fileMaxSizeMB').value ? false : true) : false)) {
                    errors.push(rule.customMessage ? (typeof rule.customMessage !== 'string' ? rule.customMessage() : rule.customMessage) : `${t('checkFieldValidity.fileMaxSizeMB.p1')}${rules.find(rule => rule.type === 'fileMaxSizeMB').value}${t('checkFieldValidity.fileMaxSizeMB.p2')}`);
                }
                break
            }
            case `iterableValidOnEmpty`: {
                valid = (value.length === 0 ? true : valid);
                if (value.length === 0) {
                    errors = [];
                }
                break
            }
            default:
                break;
        }
    }

    return {
        valid,
        errors
    }
}

export default checkFieldValidity;
